export default {
      id: "arrow_upload-usage",
      viewBox: "0 0 18 21",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#arrow_upload",
      toString: function () {
        return this.url;
      }
    }